module.exports = __webpack_public_path__ + "img/客户录入.c926704a.png";